import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from 'modules/user/userSelector';
import { userRoles, ValidUserRole } from './userRoles';

export type InvitableRoleOption = { value: ValidUserRole; label: string };

export function useInvitableRoleOptions(): InvitableRoleOption[] {
  const { t } = useTranslation();
  const { role } = useUser();

  return useMemo(
    () =>
      (Object.keys(userRoles) as ValidUserRole[])
        .filter((value) => role === 'admin' || value !== 'admin')
        .map((value) => ({ value, label: t(`userRoles.${value}`) })),
    [role, t],
  );
}
